import React, { Fragment } from "react";
import "./field.css";

function Field({
  type,
  value,
  inputName,
  options,
  name,
  errorMessage,
  handleChange,
  handleOnClick,
  placeHolder,
  disabled,
  notRequired,
  additionalInfo,
  lang,
  additionalText,
}) {
  return (
    <div className="field">
      <div className="field-label">
        {type !== "checkbox" && (
          <label htmlFor={name}>
            {name} {!notRequired && <span className="red">*</span>}
          </label>
        )}
      </div>
      {type === "dropdown" ? (
        <select
          onChange={(event) => handleChange(event)}
          name={inputName}
          value={value}
          disabled={disabled}
          className={`${errorMessage ? "error-field" : ""}`}
          onClick={(event) => handleOnClick(event)}
        >
          <option hidden={!placeHolder} value="">
            {placeHolder}
          </option>
          {options.map((item, index) => (
            <Fragment key={index}>
              <option value={item.value}>{item.text}</option>
            </Fragment>
          ))}
        </select>
      ) : type === "checkbox" ? (
        <Fragment>
          <label className="checkbox-field">
            <input
              type={type}
              className={`text-input  ${errorMessage ? "error-field" : ""}`}
              name={inputName}
              onChange={(event) => handleChange(event)}
              value={value}
              checked={value}
              disabled={disabled}
            />
            {inputName === "agreeTermAndConditions" ? (
              <Fragment>
                <span>{additionalText}</span>{" "}
                <a
                  onClick={(event) => handleOnClick(event)}
                  name="link"
                  href={`https://www.evoca.am/${lang}/cards-provision-and-service/`}
                  target="_blank"
                >
                  {name}
                </a>{" "}
                {!notRequired && <span className="red">*</span>}
              </Fragment>
            ) : inputName === "goToEvocaTouch" ? (
              <>
                <Fragment>
                  <span>{additionalText}</span>{" "}
                  <a
                    onClick={(event) => handleOnClick(event)}
                    name="link"
                    href={`https://onelink.to/evocatouch`}
                    target="_blank"
                  >
                    {name}
                  </a>{" "}
                  {!notRequired && <span className="red">*</span>}
                </Fragment>
              </>
            ) : (
              <span>
                {name} {!notRequired && <span className="red">*</span>}
              </span>
            )}
          </label>
        </Fragment>
      ) : type === "file" ? (
        <Fragment>
          <label className="custom-file-upload">
            <div>{placeHolder}</div>
            <input
              type={type}
              className={`text-input  ${errorMessage ? "error-field" : ""}`}
              accept="image/x-png , image/jpeg"
              name={inputName}
              onChange={(event) => handleChange(event)}
              value={value}
            />
          </label>
        </Fragment>
      ) : (
        <Fragment>
          <input
            className={`text-input  ${errorMessage ? "error-field" : ""}`}
            placeholder={placeHolder}
            type={type ? type : "text"}
            name={inputName}
            onClick={(event) => handleOnClick(event)}
            onChange={(event) => handleChange(event)}
            value={value}
          />
        </Fragment>
      )}
      {additionalInfo && <div className="instruction">{additionalInfo}</div>}
      <div className="field-error-message">{errorMessage}</div>
    </div>
  );
}

export default Field;
